import {GameModuleResponse} from './GameModuleResponse';
import {IRouletteWin} from '../Types/IRouletteWin';
import {RouletteSpinBet} from '../Types/RouletteSpinBet';
import {IRouletteStatistics} from '../Types/IRouletteStatistics';

/**
 * @class GameModuleRouletteResponse - game module response type of module "roulette", eq: ResponseBase->modules["roulette"].
 */
export class GameModuleRouletteResponse extends GameModuleResponse {

    /**
     * @property chosenNumber - Winning number for the game round
     */
    chosenNumber: number;

    /**
     * @property wins - List of wins as a result of a roulette spin.
     */
    wins: Array<IRouletteWin>;

    /**
     * @property totalWin - Sum of all spin wins in game round in cents (including current spin).
     */
    totalWin: number;

    /**
     * @property statistics - Roulette statistics calculated for last 500 rounds.
     */
    statistics: IRouletteStatistics;

    /**
     * @property initData - Slot initialization data. Sent only for Initialize request.
     */
    initData: {

        /**
         * @property betSettings - Bet configuration.
         */
        betSettings: {

            /**
             * @property chips - List of chips displayed on frontend.
             */
            chips?: Array<number>;
        };

        /**
         * @property lastBets - Last bets used.
         */
        lastBets: Array<RouletteSpinBet>,

        /**
         * @property lastChip - Last chip used in the previous round.
         */
        lastChip: number,

        /**
         * @property compensationEnabled - Indicates if compensation is enabled in game.
         */
        compensationEnabled: boolean;

        /**
         * @property spinWithoutBetEnabled - Indicates if the roulette allows to play rounds without any bets placed.
         */
        spinWithoutBetEnabled: boolean;

        /**
         * @property customData - Custom slot initialization data specific to game module.
         * Optional.
         */
        customData?: any;
    };

    protected internalValidate(errors: Array<string>): void {
        // TODO(lepko) add check for required properties...
    }

    public moduleName(): string {
        return 'roulette';
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/GameModuleRouletteResponse.ts
 **/